import type { FC } from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { SvgIconType } from '@thermenresorts/icons';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import Fonts from 'src/core/utils/Fonts';
import Styles from 'src/core/utils/Styles';
import SvgIcon from 'src/presentation/components/atoms/SvgIcon';

interface Props {
	title: string;
	icon: SvgIconType;
	description?: string;
	iconSize?: number;
	onPress: () => void;
}

const OptionRow: FC<Props> = ({ title, icon, description, iconSize = Dimens.iconSize24, onPress }) => {
	return (
		<Pressable
			style={({ pressed }) => [styles.card, { backgroundColor: pressed ? Colors.gray200 : Colors.white }]}
			onPress={onPress}
		>
			<View style={styles.iconSlot}>
				<SvgIcon name={icon} size={iconSize} tintColor={Colors.gray800} />
			</View>

			<View style={styles.text}>
				<Text style={styles.title}>{title}</Text>
				{description ? <Text style={styles.description}>{description}</Text> : null}
			</View>

			<SvgIcon name={SvgIconType.chevronRight} size={Dimens.iconSize12} tintColor={Colors.gray600} />
		</Pressable>
	);
};

const styles = StyleSheet.create({
	card: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: Dimens.gap14,
		padding: Dimens.padding16,
		borderRadius: Dimens.borderRadius6,
		...Styles.card.shadowSoft,
	},
	iconSlot: {
		width: Dimens.size24,
		alignItems: 'center',
	},
	text: {
		flex: Dimens.flex1,
	},
	title: {
		fontFamily: Fonts.barlowMedium,
		fontSize: Dimens.fontSize17,
		lineHeight: Dimens.lineHeight24,
		color: Colors.gray900,
	},
	description: {
		fontFamily: Fonts.barlow,
		fontSize: Dimens.fontSize12,
		lineHeight: Dimens.lineHeight20,
		color: Colors.gray550,
	},
});

export default OptionRow;
